import {CheckCircleIcon} from "@heroicons/react/20/solid";
import {useEffect, useState} from "react";
import ToggleComponent from "../generalComponents/toggleComponent";
import {Switch} from "@headlessui/react";
import {addCartItem, readCart, removeCartItem} from "../../modules/checkoutHelpers";
import PropTypes from "prop-types";


export default function AddOns(props) {
    const [isSmsEnabled, setIsSmsEnabled] = useState(false);
    const [isWebhooksEnabled, setIsWebhooksEnabled] = useState(false);

    useEffect(() => {

    }, [isSmsEnabled, isWebhooksEnabled]);

    useEffect(() => {
        const selectedItems = props.cartData?.productLineItems
        if (selectedItems && selectedItems.length > 0) {
            for (const cartItem of selectedItems) {
                if (cartItem.productIndex === 10) {
                    setIsSmsEnabled(true)
                }
                if (cartItem.productIndex === 11) {
                    setIsWebhooksEnabled(true)
                }
            }
        }
    }, [props.cartData])

    return (
        <div className="space-y-4 p-8 pt-8 rounded bg-purple-100 shadow">
            <legend className="text-lg font-bold text-gray-900">Select add-ons.</legend>
            {cellView("SMS alerts.", "Implement SMS alerts to notify customers of account updates. More than 62% of our members have enabled SMS to drive repeat customers.", "$12.00/month", isSmsEnabled,
                (newValue) => {
                    setIsSmsEnabled(newValue)

                    if (Boolean(newValue)) {
                        // Update the cart
                        let cartObject = {
                            productIndex: 10,
                            quantity: 1,
                        }
                        addCartItem(cartObject)
                        props.refreshCart()
                    } else {

                        removeCartItem(10, false, (tempData) => {
                            props.refreshCart()
                        });
                    }

            })}
            {/*{cellView("Slack Notifications", "my second", "$5.00/month", isSmsEnabled, setIsSmsEnabled)}*/}
            {cellView("Webhook receiver.", "Subscribe to webhook events for complete control into all store credit transactions. For developers.", "$16.00/month", isWebhooksEnabled,
                (newValue) => {
                setIsWebhooksEnabled(!isWebhooksEnabled)

                    if (Boolean(newValue)) {
                        // Update the cart
                        let cartObject = {
                            productIndex: 11,
                            quantity: 1,
                        }
                        addCartItem(cartObject)
                        props.refreshCart()
                    } else {

                        removeCartItem(11, false, (tempData) => {
                            props.refreshCart()
                        });
                    }
            })}
            {/*{cellView("API Support", "Access to the Pabloo API", "$79.00/month", isSmsEnabled, setIsSmsEnabled)}*/}
        </div>
    )

    function cellView(title, subtitle, price, isEnabled, setIsEnabled) {
        return (
            <div
                className="group relative flex cursor-pointer rounded-lg border border-gray-300 bg-white p-4 shadow focus:outline-hidden data-checked:border-transparent data-focus:ring-2 data-focus:ring-indigo-500"
                onClick={() => setIsEnabled(!isEnabled)}
            >
                <span className="flex flex-1">
                      <span className="flex flex-col">
                          <span className="block text-base font-semibold text-gray-900">{title}</span>
                          <span className="mt-1 text-sm items-center text-gray-700 "> {subtitle} </span>
                          <span className="mt-4 text-sm font-medium text-gray-900">{price}</span>
                      </span>
                </span>
                <div className="">
                    <ToggleComponent isEnabled={isEnabled} setIsEnabled={(tempValue) => {
                        console.log("STEP 1", tempValue)
                        setIsEnabled(!isEnabled);
                    }} />
                </div>
                {/*{*/}
                {/*    isEnabled && (*/}
                {/*        <CheckCircleIcon*/}
                {/*            aria-hidden="true"*/}
                {/*            className="size-5 text-indigo-600 group-not-data-checked:hidden"*/}
                {/*        />*/}
                {/*    )*/}
                {/*}*/}
                <span
                    aria-hidden="true"
                    className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-checked:border-indigo-500 group-data-focus:border"
                />
            </div>
        )
    }
}


AddOns.propTypes = {
    refreshCart: PropTypes.func,
    cartData: PropTypes.object,
}